var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "url(#pattern0)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1_89",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_1_89",
  width: 96,
  height: 96,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAB5klEQVR4nO3cPY4TQRRF4VNjBKhFjBB7IYEMicnZgAMiltBiBUQESMTkkJBAMntxQIwsgjFNAA0DCGzGY9d7VefLLZXusdp/coMkSZIkSZIkSZIkSZKkf1mOq2E5roba5/gfJ7UPcFWW42o4Z/Fmw+Ldk/Hjrdrn2VWpfYCrMI/PxAOAUji7QXn4Yrz9qfbZtkkf4PfxZ1kipA7wt/FnGSKkDbBt/Fn0CClfhJfjajifFm+3jQ8wTdz7PPH6GOe6jHQBfjzz4f6OD1mX6cvzQ55pH6kuQbtedi5Yl2k6ffXszvuDHmwPaQK0OD4kCdDq+JAgQMvjQ/AArY8PgQP0MD4EDdDL+BAwQE/jQ7AAvY0PgQL0OD4ECdDr+BAgQM/jQ+UAvY8PFQM4/jdVAjj+T0cP4Pi/OmoAx/9Tul/EWuMlqDJfhCvzbWhlfhCrzK8iKqseAPqOECIA9BshTADoM0KoANBfhHABoK8IIQNAPxHCBoA+IoQOAO1HCB8A2o6QIgC0GyFNAGgzQqoA0F6EdL+IvRzvrq+xOQU+7PiQYSonTw95pn2kCwDfI5TNIwpbn9WlcHaz8PgY57qMdJegi/yjdgDeqiAAb9YRwByhwPUs4zcn4w2bJEmSJEmSJEmSJEmSpAP4CiXnvb2qrpnhAAAAAElFTkSuQmCC"
}))));
export default __webpack_public_path__ + "teg/media/leftback.9e10a11b.svg";
export { SvgComponent as ReactComponent };